module.exports = __webpack_public_path__ + "static/img/footer.c9f5abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer.png
// module id = Seto
// module chunks = 113